export const profileSelector = (state) => state.app.profile
export const getFeatureListSelector = (state) => state.app.featureList
export const getInvoiceNoSelector = (state) => state.app.invoiceNumber
export const getMenuListSelector = (state) => state.app.menuList
export const getLoginDetails = (state) => state.app.loginDetails
export const getLanguageSelector = (state) => state.app.language
